import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../AutoFocus'

import buttonStyle from 'Styles/button.css'
import panelStyle from 'Styles/panel.css'
import style from './style.css'

import closeImg from 'Assets/x-icon-gray.svg'

function renderContentHint (hint) {
  return (
    <h2
      className={style.textHint}
      dangerouslySetInnerHTML={{ __html: hint.message }}
    />
  )
}

function renderHintForMCorSC (hint) {
  return (
    <h2 className={style.textHint}>
      <p className={style.hintPreText}>The answer is not:</p>
      <p
        className={style.textHintAnswer}
        dangerouslySetInnerHTML={{ __html: hint.answer }}
      />
      <p dangerouslySetInnerHTML={{ __html: hint.feedback }} />
    </h2>
  )
}

function renderHintForFB (hint) {
  return (
    <h2 className={style.textHint}>
      <p>{hint.meta}</p>
    </h2>
  )
}

function renderNoHint () {
  return (
    <h2 className={style.textNoHint}>
      <p>
        Sorry! No more hints available.
      </p>
      <p className={style.textNoHintFeedback}>
        Try reading the ebook page, and if you're still stumped, use the "show answer" button.
      </p>
    </h2>
  )
}

function renderHint (hintType, hintObj) {
  switch (hintType) {
    case 'CONTENT_HINT':
      return renderContentHint(hintObj)
    case 'MCSC_HINT':
      return renderHintForMCorSC(hintObj)
    case 'FB_HINT':
      return renderHintForFB(hintObj)
    case 'NO_HINT':
      return renderNoHint()
    default:
      return null
  }
}

export default function QuestionHint (props) {
  const renderedHintComponent = renderHint(props.hint.type, props.hint)
  return (
    <div
      data-test-id="QuestionHint"
      className={classnames(panelStyle.large, style.container)}
    >
      <button
        className={classnames(buttonStyle.rectangle, style.hideHint)}
        onClick={props.onClick}
      >
        <img
          src={closeImg}
          alt="Close this hint"
          className={style.closeIcon}
        />
      </button>
      <h2 className={style.hintLabel}>
        {props.hint.type === 'NO_HINT' ? null : 'Hint'}
      </h2>
      <AutoFocus check={props.hint}>
        {renderedHintComponent}
      </AutoFocus>
    </div>
  )
}
QuestionHint.propTypes = {
  hint: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
}
